<div class="container is-narrow">
  <a
    *ngIf="!isFromOrganisations"
    restrict-permission
    [routerLink]="['/administration', 'users']"
    data-e2e="link-back"
    title="Back to users"
    i18n-title
  >
    <span class="icon is-small">
      <i class="fas fa-chevron-left fa-xs" aria-hidden="true"></i>
    </span>
    <span i18n>Users</span>
  </a>

  <a
    *ngIf="isFromOrganisations"
    restrict-permission
    [routerLink]="['/administration', 'organisations']"
    data-e2e="link-back"
    title="Back to organizations"
    i18n-title
  >
    <span class="icon is-small">
      <i class="fas fa-chevron-left fa-xs" aria-hidden="true"></i>
    </span>
    <span i18n>Organizations</span>
  </a>

  <h1 class="title is-2" i18n>Group Details</h1>

  <div class="box" *ngIf="!isEditForm && loading$ | async">
    <portal-spinner
      [isHorizontal]="true"
      [isSmall]="true"
      text="Loading Group Details"
      i18n-text
    ></portal-spinner>
  </div>

  <div *ngIf="!isEditForm && !(loading$ | async)">
    <div class="box form-organization-group">
      <h2 class="title is-3" i18n>General Details</h2>
      <div class="label" i18n>Group name</div>
      <div class="box has-background-white-bis is-shadowless is-borderless p-2">
        <span class="has-text-grey-darker" data-e2e="groupOrganization-name">{{
          groupViewDetailEdit?.groupOrganization?.name || '-'
        }}</span>
      </div>
      <div class="box__separator"></div>

      <h2 class="title is-3" i18n>Access Rights</h2>
      <label class="field">
        <div class="label" i18n>Parent Organization</div>
        <div class="box has-background-white-bis is-shadowless is-borderless p-2">
          <span
            class="button is-static has-background-info-lighter has-text-grey-darker is-borderless"
            data-e2e="parentOrganization-name"
            >{{ groupViewDetailEdit?.parentOrganization?.name || '-' }}</span
          >
        </div>
      </label>

      <label class="field">
        <div class="label" i18n>Organizations</div>
        <portal-spinner *ngIf="isOrganisationLoading"></portal-spinner>
        <div *ngIf="selectedEntityListGroupOrganisation.length" class="notification is-info mt-1">
          <div class="icon">
            <i class="far fa-info-circle fa-lg"></i>
          </div>
          <p i18n>
            When you select an organization, all its associated child organizations will automatically be included in the group.
          </p>
        </div>
        <div *ngIf="!isOrganisationLoading">
          <div
            class="box has-background-white-bis is-shadowless is-borderless br-1 p-2"
            *ngIf="groupViewDetailEdit?.subOrganizations.length"
          >
            <span
              class="button is-static has-background-info-lighter has-text-grey-darker is-borderless my-1 mr-2"
              *ngFor="let selectedEntity of groupViewDetailEdit?.subOrganizations"
              >{{ selectedEntity.name }} {{ selectedEntity.count ? '(' + selectedEntity.count + ')' : '' }}
            </span>
          </div>
          <div
            class="box has-background-white-bis is-shadowless is-borderless has-text-centered br-1 p-2"
            *ngIf="!groupViewDetailEdit?.subOrganizations.length"
          >
            -
          </div>
        </div>
      </label>

      <!-- Display Group By information if restrictByLabels exist -->
      <label class="field" *ngIf="getGroupByInfo()">
        <div class="label" i18n>Additionally restrict by</div>
        <div class="box has-background-white-bis is-shadowless is-borderless p-2">
          <span class="has-text-grey-darker" data-e2e="group-by-type">{{ getGroupByType() }}</span>
        </div>
      </label>

      <label class="field" *ngIf="getGroupByInfo()">
        <div class="label">
          <span *ngIf="getGroupByType() === 'Acquirers'" i18n>Selected acquirers</span>
          <span *ngIf="getGroupByType() === 'Processors'" i18n>Selected processors</span>
        </div>
        <div class="box has-background-white-bis is-shadowless is-borderless p-2">
          <span
            class="button is-static has-background-info-lighter has-text-grey-darker is-borderless my-1 mr-2"
            *ngFor="let item of getSelectedItems()"
            data-e2e="selected-item"
            >{{ formatItemName(item) }}</span
          >
        </div>
      </label>

      <label *ngIf="groupViewDetailEdit?.users.length" class="field">
        <div class="label" i18n>User(s)</div>
        <portal-spinner *ngIf="isUsersLoading"></portal-spinner>
        <div *ngIf="!isUsersLoading">
          <div
            class="box has-background-white-bis is-shadowless is-borderless br-1 p-2"
            *ngIf="groupViewDetailEdit.users.length"
          >
            <span
              class="button is-static has-background-info-lighter has-text-grey-darker is-borderless my-1 mr-2"
              *ngFor="let selectedUsers of groupViewDetailEdit.users"
              >{{ selectedUsers.name }}
            </span>
          </div>
        </div>
      </label>
    </div>

    <div class="columns is-vcentered is-flex is-variable">
      <div class="column has-text-right">
        <button
          type="button"
          class="button is-primary is-outlined"
          data-e2e="button-edit-organization-group"
          *restrictPermission="['edit-details-organization-group']"
          (click)="onEditGroupForm()"
        >
          <span i18n> Edit</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!isEditForm" class="notification is-info mb-5 mt-4">
    <div class="icon">
      <i class="far fa-info-circle fa-lg"></i>
    </div>
    <p i18n>
      Assigning a user to a group is not permitted on this page. To change a user's organization to a group,
    please navigate to the user's detail (edit) page, where you can select the group organization when updating the user's organization.
    <a
    restrict-permission
    (click)="navigateToUsers()"
    data-e2e="link-back"
    title="Back to users"
    i18n-title
  >Users</a>
    </p>
  </div>

  <div *ngIf="isEditForm">
    <portal-form-organization-group
      [groupModeEdit]="true"
      [groupViewDetailEdit]="groupViewDetailEdit"
      [selectedParentEntity]="groupViewDetailEdit.parentOrganization"
      [isButtonDisabled]="isButtonDisabled"
      [isSaving]="isSaving"
      (closeEditForm)="closeEditForm($event)"
      (formValidated)="onFormValidated($event)"
      (selectedOrganizationNumber)="onSelectedOrganizationNumber($event)"
      (entityListGroupOrganisationUpdated)="setEntityListGroupOrganisation($event)"
    ></portal-form-organization-group>
  </div>
</div>
